import firebase, { hvoAuth } from "../../configs/FirebaseConfig";

export const getFirebaseIDToken = () => {
  return new Promise((resolve, reject) => {
    if (!!firebase.auth().currentUser) {
      firebase
        .auth()
        .currentUser.getIdToken(true)
        .then((idToken) => resolve(idToken))
        .catch((error) => reject(error));
    } else reject("No user logged in");
  });
};

/**
 * ID token for the api of one specific shop.
 *
 * Each shop's api verifies tokens against its own Firebase project, so a VCE-issued token is
 * rejected by the HVO api and vice versa. The CMS signs in to both projects at login (see
 * `loginToBothFirebase`), so an HVO token is normally available - if it isn't, the user has no
 * account in the HVO project and needs one, rather than a request that fails as "unauthorized".
 */
export const getFirebaseIDTokenForShop = (shopSource) => {
  if (shopSource !== "HVO") return getFirebaseIDToken();
  return new Promise((resolve, reject) => {
    const hvoUser = hvoAuth.currentUser;
    if (!hvoUser) {
      reject(
        new Error(
          "Niet ingelogd op het Halalvlees Online Firebase-project. Log opnieuw in; bestaat je account daar niet, " +
            "dan moet die eerst aangemaakt worden.",
        ),
      );
      return;
    }
    hvoUser
      .getIdToken(true)
      .then((idToken) => resolve(idToken))
      .catch((error) => reject(error));
  });
};
